<template>
  <Form>

    <div class="text-center py-5 px-5">
      <h4>Cadastrar uma senha</h4>
    </div>

    <div class="input-group pb-3">
      <span class="input-group-text"><LockIcon/></span>
      <input v-model="user.password" placeholder="Digite sua senha"
             :type="showPassword ? 'text' : 'password'"
             @keypress.enter="send()"
             class="form-control input"
             autocomplete="new-password"/>
      <i class="eye-password" @click="showPassword = !showPassword"
        :title="showPasswordConfirmation ? 'Ocultar Senha' : 'Mostrar Senha'">
        <EyeIcon v-if="showPassword"/>
        <EyeOffIcon v-else/>
      </i>
    </div>

    <div class="input-group">
      <span class="input-group-text" id="password"><LockIcon/></span>
      <input v-model="user.passwordConfirmation" placeholder="Confirme sua senha"
             :type="showPasswordConfirmation ? 'text' : 'password'"
             @keypress.enter="send()"
             class="form-control input"
             autocomplete="new-password"/>
      <i class="eye-password" @click="showPasswordConfirmation = !showPasswordConfirmation"
        :title="showPasswordConfirmation ? 'Ocultar Senha' : 'Mostrar Senha'">
        <EyeIcon v-if="showPasswordConfirmation"/>
        <EyeOffIcon v-else/>
      </i>
    </div>

    <div class="form-group pb-5">
      <div class="row">
        <div id="sign-up" class="btn-group col-md-12 mt-3">
          <button @click="send()" class="btn btn-primary">Salvar</button>
        </div>
      </div>

      <div class="row">
        <div id="sign-in" class="btn-group col-md-12 mt-3">
          <small class="mx-auto">Já possui uma conta?
            <a href="#" @click="sendLogin()" class="link">Clique aqui</a> para fazer login!
          </small>

        </div>
      </div>
    </div>

  </Form>
</template>

<script>
  import Form from '@/components/auth/Form'
  import { EyeIcon, EyeOffIcon, LockIcon } from 'vue-feather-icons'

  export default {
    components: { EyeIcon, EyeOffIcon, Form, LockIcon },
    created() {
      this.user.currentPassword = this.$route.query.token
      this.user.id = this.$route.query.id
      this.user.accountId = this.$route.query.account_id
    },
    data: () => ({
      nameModel: 'User',
      showPassword: false,
      showPasswordConfirmation: false,
      user: {
        currentPassword: '',
        password: '',
        passwordConfirmation: ''
      }
    }),
    methods: {
      send() {
        const user = this.$parse.toSnakecase(this.user)
        this.axios.put(`users/${user.id}/set_password`, user)
          .then(() => this.$notify.add('Senha cadastrada!'))
          .then(() => this.sendLogin())
          .catch(e => this.$notify.addError(e))
      },
      sendLogin() {
        this.$router.push('login')
      }
    },
    name: 'RegisterPassword'
  }
</script>

<style scoped>
  .eye-password {
    position: absolute;
    top: 8px;
    right: 13px;
    cursor: pointer;
    z-index: 5;
  }
</style>
